
<div>
  <span>{{codableConcept?.text || codableConcept?.coding?.[0]?.display}}</span>
  <span *ngIf="codableConcept?.coding?.[0]?.code" [title]="codableConcept?.coding?.[0]?.system">
  ({{codableConcept?.coding?.[0]?.code || '?'}})
  </span>
</div>
